import { Dimensions } from "react-native";
import { Orientation } from "expo-screen-orientation";
import { TABLET_PC } from "src/common/libs/utils/constants";

const screenWidth = Dimensions.get("screen").width;
const screenHeight = Dimensions.get("screen").height;


const SIDE_BAR_WIDTH = 240;

const calcNumColumns = (orientation, scaling = 0.75, scWidth = screenWidth, scHeight = screenHeight) => {
  const calcWidth =
    orientation === Orientation.LANDSCAPE_LEFT ||
    orientation === Orientation.LANDSCAPE_RIGHT
      ? Math.max(scWidth, scHeight)
      : Math.min(scWidth, scHeight);
  const calcHeight =
    orientation === Orientation.LANDSCAPE_LEFT ||
    orientation === Orientation.LANDSCAPE_RIGHT
      ? Math.min(scWidth, scHeight)
      : Math.max(scWidth, scHeight);
  const itemHeight = calcHeight * 0.25;
  const numColumns = TABLET_PC
    ? Math.max(
        Math.floor(((calcWidth - SIDE_BAR_WIDTH) / itemHeight) * scaling),
        2
      )
    : 2;

  return numColumns;
};

const getScreenHeightWidth = (orientation) => {
  const width =
    orientation === Orientation.LANDSCAPE_LEFT ||
    orientation === Orientation.LANDSCAPE_RIGHT
      ? Math.max(screenWidth, screenHeight)
      : Math.min(screenWidth, screenHeight);
  const height =
    orientation === Orientation.LANDSCAPE_LEFT ||
    orientation === Orientation.LANDSCAPE_RIGHT
      ? Math.min(screenWidth, screenHeight)
      : Math.max(screenWidth, screenHeight);

  return { width, height };
};

export { calcNumColumns, getScreenHeightWidth };
